import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';

import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateModule } from '@ngx-translate/core';

//** ngx-translate v17+: TranslateHttpLoader uses dependency injection, no factory needed
@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		HttpClientModule,
		TranslateModule.forRoot({ fallbackLang: 'en' }),
	],
	providers: [
		provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
	],
	exports: [TranslateModule],
})

export class NgxTranslateModule { }
